import { Script } from "../../components/Script";

/**
 * 保持对2.0的兼容。新脚本支持使用Script即可。
 */
export var Script3D = Script;
export type Script3D = Script;
